import Vue from "vue";
import axios from "axios";
function _calculateAge(birthday) {
  birthday = new Date(birthday)
  let ageDifMs = Date.now() - birthday.getTime();
  let ageDate = new Date(ageDifMs);
  return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export default {
  namespaced: true,
  state: {
    abiturient: {},
    abiturientModel: {},
    user_moodle:false,
    mag_portal_exams:false,
  },
  getters: {
    abiturient: (state) => {
      state.abiturient["age"] = _calculateAge(state.abiturient.birthday)
      return state.abiturient
    },
    user_moodle:(state)=>{
      return state.user_moodle;
    },
    mag_portal_exams:(state)=>{
      return state.mag_portal_exams;
    }
  },
  mutations: {
    SET_ABITURIENT(state, payload) {
      state.abiturient = payload;
    },
    SET_MAG_PORTAL_EXAMS(state,payload){
      state.mag_portal_exams=payload;
    },
    SET_USER_MOODLE(state,payload){
      state.user_moodle=payload;
    },
    UPDATE_ABITURIENT_MODEL(state, payload) {
      Object.keys(payload).map(function (key) {
        state.abiturientModel[key] = payload[key]
      });
    },
    CLEAR_ABITURIENT_MODEL(state) {
      state.abiturientModel = {}
    },
  },
  actions: {
    async loadAbiturient({commit}) {
      await Vue.axios.get('abiturient/')
        .then((response) => {
          commit('SET_ABITURIENT', response.data)
        })
    },
    async loadMagExams({commit,dispatch}){
      await axios.get('https://portal.kuzstu.ru/api/abit_mag_2022')
         .then(response=>{
            commit('SET_MAG_PORTAL_EXAMS',response.data[0].results);
          })
         .catch(error=>{
           dispatch('django/handleError', {error}, {root: true});
         })
    },
    loadUserMoodle({commit,state,dispatch}){
      Vue.axios.get('application/user_exams/',{params:{'user':state.abiturient.user.id}})
         .then(response=>{
            commit('SET_USER_MOODLE',response.data.results[0]);
          })
         .catch(error=>{
            dispatch('django/handleError', {error}, {root: true});
          })
    },
    async update({state, dispatch, commit}) {
      await Vue.axios.patch('abiturient/update/', state.abiturientModel)
        .then((response) => {
          commit('SET_ABITURIENT', response.data);
          commit('CLEAR_ABITURIENT_MODEL');
        })
        .catch((error) => {
          dispatch('django/handleError', {error}, {root: true})
        })
    },
  }
}
